const SOURCE_ACCOUNT_DIVIDER = "::";
const SOURCE_ACCOUNT_REIMBURSEMENT_SUFFIX = "reimbursement";

export function isRampReimbursementAccount(account: {
    sourceAccountId: string | null;
}): boolean {
    const { sourceAccountId } = account;

    if (!sourceAccountId) {
        return false;
    }

    const [, suffix] = sourceAccountId.split(SOURCE_ACCOUNT_DIVIDER);

    return suffix === SOURCE_ACCOUNT_REIMBURSEMENT_SUFFIX;
}

export function buildRampReimbursementSourceAccountId(
    baseSourceAccountId: string,
): string {
    return [baseSourceAccountId, SOURCE_ACCOUNT_REIMBURSEMENT_SUFFIX].join(
        SOURCE_ACCOUNT_DIVIDER,
    );
}
